import React from "react"
import "./kpis-wrapper.scss"

export const KpisWrapper = ({children}) => {
    return (
        <div className="kpis-wrapper">
           {children}
        </div>
    )
}